import { useState } from "react";
import { useFormContext } from "react-hook-form";

import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import AddIcon from "@mui/icons-material/Add";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import { useAppSelector } from "app/hooks";
import ReferralSourceField from "components/referral-source-field";
import ReferralSourceShortForm from "components/referral-source-short-form/index";
import SubReferralSourceField from "components/sub-referral-source-field";
import { patientSettingsSelector } from "features/auth/auth-slice";
import useUserRoles from "hooks/use-user-roles.hook";

export default function ReferralSourceFieldCombo() {
  const { control, setValue } = useFormContext();

  const patientSettings = useAppSelector(patientSettingsSelector);
  const isReferralSourceRequired =
    patientSettings?.required_fields?.referral_source;
  const isSubReferralSourceRequired =
    isReferralSourceRequired &&
    patientSettings?.required_fields?.sub_referral_source;

  const [isOpenForm, setFormIsOpen] = useState<boolean>(false);

  const { isAdminOrBusinessOwner } = useUserRoles();

  return (
    <>
      <Box display="flex" justifyContent="space-between">
        <AccountCircleOutlinedIcon sx={{ mt: "30px", mr: 1.5 }} />
        <Grid container width="100%" spacing={4}>
          <Grid item xs={5}>
            <ReferralSourceField
              required={isReferralSourceRequired}
              control={control}
              afterUpdate={() => {
                setValue("sub_referral_source", "", {
                  shouldDirty: true,
                  shouldValidate: true
                });
                setValue("sub_referral_source_object", null, {
                  shouldDirty: true,
                  shouldValidate: true
                });
              }}
              addButton={
                isAdminOrBusinessOwner ? (
                  <Tooltip title="Add new">
                    <IconButton
                      size="small"
                      onClick={() => {
                        setFormIsOpen(true);
                      }}
                      color="success"
                      sx={{ padding: 0, border: "1px solid #ccc" }}
                    >
                      <AddIcon color="success" fontSize="small" />
                    </IconButton>
                  </Tooltip>
                ) : undefined
              }
            />
          </Grid>
          <Grid item xs={7}>
            <SubReferralSourceField
              required={isSubReferralSourceRequired}
              control={control}
            />
          </Grid>
        </Grid>
      </Box>

      <ReferralSourceShortForm
        isOpen={isOpenForm}
        onClose={() => setFormIsOpen(false)}
        onAdd={(id) => {
          setValue("referral_source", id.toString());
        }}
      />
    </>
  );
}
